<!--Barra inferior que se sale en el detalle de un evento-->
<template>
  <v-row justify="center" align="center" class="bottom-navbar white--text" :class="[{ 'bottom-navbar--hidden': !showNavbar }, (currentEvent.hasOwnProperty('darkMode') && currentEvent.darkMode)?'dark-mode':'primary']">
    <v-btn v-if="currentEvent.estatus === 'ACTIVE' && $route.params.id != '601c44ead689f90008e03fe8'" active-class="accent" large color="accent" class="black--text font-weight-bold" :to="urlCheckout()">
      Adquirir acceso
    </v-btn>
    <v-btn v-else-if="currentEvent.estatus === 'ACTIVE' && $route.params.id == '601c44ead689f90008e03fe8'" active-class="accent" large color="accent" class="black--text font-weight-bold" :to="urlCheckout()">
      Adquirir paquete
    </v-btn>
    <v-btn v-else active-class="accent" large color="accent" class="black--text font-weight-bold" to="/eventos">Explorar más eventos</v-btn>
  </v-row>
</template>
<!--this.$route.params.id == "601c44ead689f90008e03fe8"-->
<script>
import { mapMutations, mapState } from 'vuex'
  export default {
    data () {
      return {
        showNavbar: false
      }
    },
    async mounted () {
      //await this.isTicketsOutOfStock();
      window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
      //this.ticketsOutOfStock = true;
      //this.currentEvent = {};
      window.removeEventListener('scroll', this.onScroll)
    },
    methods:{
      ...mapMutations('user',['leavingEventPreview']),
      onScroll () {
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
        if (currentScrollPosition < 800)
          this.showNavbar = false;
        else
          this.showNavbar = true;
      },
      urlCheckout(){
        let formattedUrl = this.$route.fullPath.split('?');
        return `${formattedUrl[0]}/checkout`;
      },
      isTicketsOutOfStock(){
        if (this.currentEvent){
          this.currentEvent.tickets.forEach(ticket => {
            if (ticket.inventory.quantity > ticket.inventory.sold || ticket.inventory.inventoryType == 'INFINITE') {
              this.ticketsOutOfStock = false;
              return;
            }
          });
        //  if (this.ticketsOutOfStock) {
        //    return true;
        //  } else {
        //    return false;
        //  }
        //}else {
        //  return true;
        }
      },
    },
     computed:{
      ...mapState("event", ["currentEvent","ticketsOutOfStock"]),
    },
  }
</script>
<style scoped>
.bottom-navbar{
  position: fixed;
  bottom: -1px;
  width: 100vw;
  height: 60px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  transition: 0.25s all ease-out;
}

.bottom-navbar.bottom-navbar--hidden {
  box-shadow: none;
  transform: translate3d(0, 100%, 0);
}

@media (max-width: 1264px){
  .bottom-navbar{
    width: 105vw;
  }
}

@media (min-width: 1264px) and (max-width: 1903px)  {
  .bottom-navbar{
    height: 12vh;
  }
}

@media (min-width: 1904px) {
  .bottom-navbar{
    height: 8vh;
  }
}
</style>

